<template>
    <div class="investment-experience-4">

        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="280px" class="demo-ruleForm">

            <el-form-item label="" prop="is_financial_experience">
              <p>Have you gained relevant professional experience working in Financial Services
                  <br/>(i.e. Broker, Investment Manager, Trader)?</p>
              <el-radio-group v-model="ruleForm.is_financial_experience" class="radio-reset">
                <el-radio :label="1">Yes</el-radio>
                <el-radio :label="0">No</el-radio>
              </el-radio-group>
            </el-form-item>

            <template v-if="Number(ruleForm.is_financial_experience)===1">
              <el-form-item  label="Role Title :" prop="financial_experience_role" style="margin-left:87px" >
                  <el-input v-model="ruleForm.financial_experience_role" style="width:217px;"></el-input>
              </el-form-item>

              <el-form-item label="Time spent performing role :" class="financial-experience-year" prop="financial_experience_year" style="margin-left:268px">
                  <el-select v-model="ruleForm.financial_experience_year" placeholder="Please Select" style="width:217px;">
                      <el-option  :value="val" :label="val" v-for="(val,key) in fieldOptions.financial_experience_year"></el-option>
                  </el-select>
              </el-form-item>
            </template>


            <el-form-item label="" prop="is_big_deal">
              <p>Have performed an average of at least 10 transactions per quarter, of significant size, over the previous four quarters on the relevant market (e.g. derivatives such as CFDs)? </p>
              <el-radio-group v-model="ruleForm.is_big_deal" class="radio-reset">
                <el-radio :label="1">Yes</el-radio>
                <el-radio :label="0">No</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="" prop="is_financial_education">
              <p>Have you attended a Financial Trading Education Course in the last 3 years?</p>
              <el-radio-group v-model="ruleForm.is_financial_education" class="radio-reset">
                <el-radio :label="1">Yes</el-radio>
                <el-radio :label="0">No</el-radio>
              </el-radio-group>
            </el-form-item>

            <el-form-item label="" prop="is_used_demo">
              <p>Have you used our Demo Account?</p>
              <el-radio-group v-model="ruleForm.is_used_demo"  class="radio-reset">
                <el-radio :label="1">Yes</el-radio>
                <el-radio :label="0">No</el-radio>
              </el-radio-group>
            </el-form-item>

            <template v-if="Number(ruleForm.is_used_demo)===1">
              <el-form-item  prop="used_demo_time">
                  <p>How long have you had the Demo Account?</p>
                  <el-select v-model="ruleForm.used_demo_time" placeholder="Please Select">
                      <el-option  :value="val" :label="val" v-for="(val,key) in fieldOptions.used_demo_time"></el-option>
                  </el-select>
              </el-form-item>

              <el-form-item  prop="used_demo_often">
                  <p>How often have you used the Demo Account?</p>
                  <el-select v-model="ruleForm.used_demo_often" placeholder="Please Select">
                      <el-option  :value="val" :label="val" v-for="(val,key) in fieldOptions.used_demo_often"></el-option>
                  </el-select>
              </el-form-item>
            </template>

            <el-form-item>
                <el-button @click="resetForm('ruleForm')" class="box-btn-default" style="width: 211px;">BACK</el-button>
                <el-button type="primary" @click="submitForm('ruleForm')" :loading="btn_loading" class="box-btn"  style="width: 221px;">NEXT</el-button>
            </el-form-item>

        </el-form>

    </div>
</template>

<script>
import * as server from '../action'

export default {
  data() {
    return {
      fieldOptions: {},
      ruleForm: {
        is_financial_experience: '',
        financial_experience_role: '',
        financial_experience_year: '',
        is_financial_education: '',
        is_big_deal: '',
        is_used_demo: '',
        used_demo_time: '',
        used_demo_often: ''
      },
      rules: {
        is_financial_experience: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        financial_experience_role: [
          { required: true, message: 'Please Enter', trigger: 'change' }
        ],
        financial_experience_year: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        is_big_deal: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        is_financial_education: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        is_used_demo: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        used_demo_time: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ],
        used_demo_often: [
          { required: true, message: 'Please Select', trigger: 'change' }
        ]
      },
      btn_loading: false
    }
  },
  created() {
    server.certification_apply_index({ step: 5 }, true).then(res => {
      this.fieldOptions = res.data.fieldOptions
      Object.keys(this.ruleForm).map((val, key) => {
        if (
          val === 'is_financial_experience' ||
          val === 'is_financial_education' ||
          val === 'is_used_demo' ||
          val === 'is_big_deal'
        ) {
          this.ruleForm[val] =
            res.data.setting[val] === 0 || res.data.setting[val] === 1
              ? res.data.setting[val]
              : ''
        } else {
          this.ruleForm[val] = res.data.setting[val] || ''
        }
      })
    })
  },
  methods: {
    submitForm(formName) {
      this.btn_loading = true
      this.$refs[formName].validate(valid => {
        if (valid) {
          if (Number(this.ruleForm.is_financial_experience) === 0) {
            this.ruleForm.financial_experience_role = ''
            this.ruleForm.financial_experience_year = ''
          }
          if (Number(this.ruleForm.is_used_demo) === 0) {
            this.ruleForm.used_demo_time = ''
            this.ruleForm.used_demo_often = ''
          }
          let params = {
            ...this.ruleForm,
            step: 5
          }
          server
            .certification_apply_save(params, true)
            .then(res => {
              if (res.data.status === 'refuse') {
                this.$alert(
                  `Unfortunately, based on the information submitted by you, we are unable to proceed with your
                   application. If you believe there were errors in the information provided, you can go back and change them and submit again. Upon rejection from us,
                  should there be any change in your own circumstances, please feel free to contact us again. `,
                  'Rejection Message',
                  {
                    dangerouslyUseHTMLString: true,
                    confirmButtonText: 'OK',
                    center: true
                  }
                )
                  .then(() => {})
                  .catch(action => {})
              } else if (res.code === 200) {
                this.$emit('onStopIndex', 6)
              }
              this.btn_loading = false
            })
            .catch(err => {
              console.log('err', err)
              this.btn_loading = false
            })
        } else {
          this.btn_loading = false
          return false
        }
      })
    },
    resetForm(formName) {
      this.$emit('onStopIndex', 4)
      this.$refs[formName].resetFields()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style  lang="scss">
.investment-experience-4 {
  .info-one {
    font-size: 16px;
    line-height: 25px;
    letter-spacing: 0px;
    color: #333333;
    padding-left: 270px;
    margin: 30px 0 20px;
    font-weight: bold;
  }
  .select-title {
    padding-left: 300px;
    margin-bottom: 20px;
    line-height: 25px;
    letter-spacing: 0px;
    color: #0A95FF;
  }
  .checkbox-reset {
    > label {
      display: block;
      margin-left: 0;
    }
  }
  .checkbox-top-text {
    font-size: 14px;
    line-height: 25px;
    color: #666666;
    margin-left: 224px;
    margin-bottom: 8px;
    em {
      color: #0A95FF;
    }
  }
  .radio-reset {
    .el-radio__input.is-checked .el-radio__inner {
      border-color: #0A95FF;
      background: #0A95FF;
    }
    .el-radio__input.is-checked + .el-radio__label {
      color: #0A95FF;
    }
  }
  .financial-experience-year {
    .el-form-item__label {
      width: 100px !important;
      line-height: 20px;
    }
    .el-form-item__content {
      margin-left: 100px !important;
    }
  }
}
</style>
